import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, UpdatePlaidDialogueHandler } from './types';
import UpdatePlaidCpmtext from './UpdatePlaidContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type PlaidDialogueProps = {
  handleDialogue: DialogueHandler<UpdatePlaidDialogueHandler>;
};

type FC = FunctionComponent<PlaidDialogueProps>;

const UpdatePlaidDialogue: FC = ({ handleDialogue }: PlaidDialogueProps) => {
  const { showUpdateSuccessAlert, showUpdateErrorAlert, UpdateError } = useContext(UpdatePlaidCpmtext);
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Plaid.Update.Dialogs' });

  return useMemo(
    () => (
      <div>
        {/* Update Error */}
        <ConfirmationDialogue
          isVisible={showUpdateErrorAlert}
          title={t('UpdateError.title')}
          status="error"
          subTitle={`${UpdateError}`}
          confirm={{
            label: t('UpdateError.confirmButton'),
            action: () => handleDialogue({ type: 'update', state: 'error' }),
          }}
        />
        {/* Update Success */}
        <ConfirmationDialogue
          isVisible={showUpdateSuccessAlert}
          title={t('UpdateSuccess.title')}
          status="success"
          subTitle={t('UpdateSuccess.subTitle')}
          confirm={{
            label: t('UpdateSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'update', state: 'success' }),
          }}
        />
      </div>
    ),
    [showUpdateSuccessAlert, showUpdateErrorAlert],
  );
};

export default UpdatePlaidDialogue;
